import React from "react";
import PageName from "../../shared/components/PageName";

import cameraVideo from "../../../shared/assets/videos/cameraVideo.mp4";

import classes from "./CamerasPage.module.css";

const StudentCamerasPage = () => {
  return (
    <div>
      <PageName pageName="Cameras" />
      <video autoPlay className={classes["camera"]} src={cameraVideo}></video>
      <p className={classes["text"]}>9-A sinf</p>
    </div>
  );
};

export default StudentCamerasPage;
